<template>
    <el-dialog title="选择小程序" :visible.sync="innerVisible" class="dialog-table" width="700px" :before-close="closeDialogTable">
        <div class="tableTh">
            <el-table :data="tableData" ref="singleTable" border  highlight-current-row
                      @current-change="handleCurrentChangeTable" style="width: 100%" class="tableStyle table-radio">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.appId"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="appId" label="小程序ID">
                </el-table-column>
                <el-table-column prop="name" label="小程序名">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
// import { getAppList } from "@/api/dysvzk/base/get";
export default {
    name: 'AppTable',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        selectApp: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            tableData: {},
            currentPage: 1,
            pageSize: 100,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            console.log("----",this.selectApp)
            this.$nextTick(()=>{
                this.$refs.singleTable.setCurrentRow(this.selectApp)
            })
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        }
    },
    mounted() {
        this.tableData = JSON.parse(localStorage.getItem('appList'))
        // this.getTableApp()
    },
    methods: {
        // 单选
        handleCurrentChangeTable(val) {
            console.log(val)
            this.$refs.singleTable.setCurrentRow(val);
            this.currentRow = val
            this.selected = [val.appId]
        },
        // 确定按钮
        tableSureBtn() {
            this.$emit('appSure', this.currentRow);
            this.$emit('cancelDialogApp', false);
            // this.closeDialogTable()
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log('关闭弹框')
            this.$emit('cancelDialogApp', false);
            // this.$refs.singleTable.setCurrentRow();
            // this.selected = []
        },
        // getTableApp() {
        //     getAppList({
        //         pageNo: this.currentPage,
        //         pageSize: this.pageSize
        //     }).then(response => {
        //         if (response.data.head.flag === 0) {
        //             this.tableData = response.data.content
        //         } else {
        //             this.$message.error(response.data.head.desc)
        //         }
        //     });
        // },
    }
}
</script>
